var $32988e2a4c68baf9$var$addRowButton = document.querySelector("#js-add-row-button");
var $32988e2a4c68baf9$var$removeRowButton = document.querySelector("#js-remove-row-button");
function $32988e2a4c68baf9$var$updateButtonStates() {
    var fieldGroups = document.querySelectorAll(".field-group");
    if (fieldGroups.length > 9) $32988e2a4c68baf9$var$addRowButton.setAttribute("disabled", true);
    else $32988e2a4c68baf9$var$addRowButton.removeAttribute("disabled");
    if (fieldGroups.length < 3) $32988e2a4c68baf9$var$removeRowButton.setAttribute("disabled", true);
    else $32988e2a4c68baf9$var$removeRowButton.removeAttribute("disabled");
}
var $32988e2a4c68baf9$var$preventFormSubmitOnEnter = function(event) {
    if (event.key === "Enter") event.preventDefault();
};
var $32988e2a4c68baf9$var$init = function() {
    $32988e2a4c68baf9$var$addRowButton.addEventListener("click", function(event) {
        event.preventDefault();
        var nodeToCopy = document.getElementById("js-copy-node");
        var fieldGroups = document.querySelectorAll(".field-group");
        if (fieldGroups.length < 10) {
            var copyAfterNode = fieldGroups[fieldGroups.length - 1];
            var clone = nodeToCopy.cloneNode(true);
            clone.removeAttribute("id");
            var cloneInput = clone.querySelector(".js-term-input");
            cloneInput.value = "";
            cloneInput.setAttribute("value", "");
            cloneInput.setAttribute("name", "qt" + fieldGroups.length);
            cloneInput.setAttribute("id", "qt" + fieldGroups.length);
            cloneInput.addEventListener("keydown", $32988e2a4c68baf9$var$preventFormSubmitOnEnter);
            var cloneOpSelect = clone.querySelector(".js-op-select");
            cloneOpSelect.setAttribute("name", "qo" + fieldGroups.length);
            cloneOpSelect.setAttribute("id", "qo" + fieldGroups.length);
            cloneOpSelect.selectedIndex = 0;
            cloneFieldLabel = clone.querySelector("label");
            cloneFieldLabel.setAttribute("for", "qf" + fieldGroups.length);
            var cloneFieldSelect = clone.querySelector(".js-field-select");
            cloneFieldSelect.setAttribute("name", "qf" + fieldGroups.length);
            cloneFieldSelect.setAttribute("id", "qf" + fieldGroups.length);
            cloneFieldSelect.selectedIndex = 0;
            copyAfterNode.parentNode.insertBefore(clone, copyAfterNode.nextSibling);
            $32988e2a4c68baf9$var$updateButtonStates();
        }
    });
    $32988e2a4c68baf9$var$removeRowButton.addEventListener("click", function(event) {
        event.preventDefault();
        var fieldGroups = document.querySelectorAll(".field-group");
        if (fieldGroups.length > 2) fieldGroups[fieldGroups.length - 1].parentNode.removeChild(fieldGroups[fieldGroups.length - 1]);
        $32988e2a4c68baf9$var$updateButtonStates();
    });
    var termInputs = document.querySelectorAll(".js-term-input");
    for(var i = 0; i < termInputs.length; i++)termInputs[i].addEventListener("keydown", $32988e2a4c68baf9$var$preventFormSubmitOnEnter);
};
window.addEventListener("load", $32988e2a4c68baf9$var$init, false);


//# sourceMappingURL=advanced-search.js.map
